import queryKeys from '@/constants/queryKeys';
import { useAppStore } from '@/store/useAppStore';
import { useInfinitePagination } from '../useInfinitePagination';
import { INFINITE_SCROLL_CARDS_PER_PAGE } from '@/constants';
import { TPeerSupportTeamMemberInfo } from '@/types/PeerSupport.types';
import { getMyOrganizationPeerSupportMembers } from '@/services/api/requests/organization';

const useOrganizationPeerSupportMembers = (itemsPerPage?: number, starredFirst = false) => {
  const { user } = useAppStore();

  return useInfinitePagination<TPeerSupportTeamMemberInfo[]>({
    query: (page, limit) => getMyOrganizationPeerSupportMembers(page, limit, starredFirst),
    queryKey: [queryKeys.peerSupport.members, user?.email ?? '', String(starredFirst)],
    limit: itemsPerPage ?? INFINITE_SCROLL_CARDS_PER_PAGE,
    getId: (member) => member.id,
  });
};

export default useOrganizationPeerSupportMembers;
